// app.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import BotDashboard from './pages/bot';
import CurlRunner from './pages/CurlRunner';
import Login from './components/Login';
import Data from './pages/data';
import { AuthProvider, useAuth } from './hooks/useAuth';

// Protected Route wrapper
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-white text-xl">Loading...</div>
      </div>
    );
  }
  
  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route 
        path="/" 
        element={
          <ProtectedRoute>
            <BotDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/curl" 
        element={
          <ProtectedRoute>
            <CurlRunner />
          </ProtectedRoute>
        } 
      />
      {/* Data routes - no auth required for data viewing */}
      <Route path="/data/*" element={<Data />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}

export default App;
